export default {
      id: "oc-dashboard-vmhistory-count-trend-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-dashboard-vmhistory-count-trend",
      toString: function () {
        return this.url;
      }
    }